module.exports = __webpack_public_path__ + "media/images/featured-graphic-94b8e941c2715db4898ecf940ccc78e0.svg";